import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { Form, Input, Modal } from "antd";
import { isDefinedAndNotNull } from "../../../swzutils";
const EditLocationContactModal = ({ open, title = "Edit Contact", contact = null, onCancel, onComplete }) => {
    const [form] = Form.useForm();
    useEffect(() => {
        if (!open) {
            form.resetFields();
        }
        else {
            form.setFieldsValue({
                name: isDefinedAndNotNull(contact?.name) ? contact?.name : null,
                telephone: isDefinedAndNotNull(contact?.telephone) ? contact?.telephone : null,
            });
        }
    }, [open]);
    const onOk = () => {
        form.submit();
    };
    const onFinish = (formValues) => {
        onComplete(formValues);
    };
    return (_jsx(Modal, { title: title, open: open, onOk: onOk, onCancel: onCancel, destroyOnHidden: true, children: _jsxs(Form, { layout: "vertical", form: form, onFinish: onFinish, children: [_jsx(Form.Item, { label: 'Name', name: 'name', initialValue: contact?.name, children: _jsx(Input, {}) }), _jsx(Form.Item, { label: 'Telephone', name: 'telephone', initialValue: contact?.telephone, children: _jsx(Input, {}) })] }) }));
};
export default EditLocationContactModal;
